import { ChartValue, GenericChartItem } from "src/app/types/chart.model"
import { Dayjs } from "dayjs"

export type ItemValueFunc = (item: Record<string, unknown>, jobIdField: string) => number

/** Per-request, per-field custom display-order rank maps.
 *  Outer key: the `ChartConfig.argumentField`/`splitByField` name this rank map applies to
 *  (e.g. `'currentActivity'`).
 *  Inner map: the field's raw string value as it appears on a data item (e.g. an activity's
 *  `description`, since that's what's stored on `ProcessedDashboardJob.currentActivity`) ->
 *  0-based rank (lower sorts first). Built via `ChartDatasourceHelper.buildRankMap()`.
 *  Resolved fresh for each chart request (e.g. zipped alongside the datasource's raw data) */
export type FieldRankMaps = Map<string, Map<string, number>>

export interface DateSeriesDate {
  startDate?: Date
  endDate?: Date
}

export interface ChartResult {
  data: GenericChartItem[]
  splitSeries: boolean

  dynamicSeries?: ChartValue[]

  /** Indicates if the chart has dynamic target values (from targetOverrides) */
  hasDynamicTarget: boolean
}

export interface FilteredItems {
  /** item has been filtered-out by date or custom filter.
   *  item is ignored when incrementing numItems or adding values
   *  populated if ChartConfig.showFilteredCategoriesOnly = false
   */
  filteredIds: (number | string)[]

  /** contains all items if ChartConfig.showFilteredCategoriesOnly = false */
  items: any[]

  dateFrom?: Dayjs | null
  dateTo?: Dayjs | null
}

export const SERIES_EMPTY_TEXT = '(Blank)'
